import React from 'react';
import firebase from 'firebase';
import AuthContext from '../Context/AuthContext';

export default function AuthProvider(props){
    const [user, setUser] = React.useState(null);
    const [isLoading, setLoading] = React.useState(true);
    const [isSignedIn, setIsSignedIn] = React.useState(false);
    let unregisterAuthObserver;

    React.useEffect(() => {

        unregisterAuthObserver = firebase.auth().onAuthStateChanged((user) => { 
            setUser(user);
            setIsSignedIn(!!user) 
            setLoading(false);
        });  

        return () => unregisterAuthObserver();
    }, [])

    const signOut = () => {
        sessionStorage.removeItem("name")
        setUser(null);
    }

    const signUp = ({ name, password }) => {
        if (name !== null && name !== "") {
            sessionStorage.setItem("name", name)
            setUser({ name: name })
        }
    }

    const login = ({ name, password }) => {
        sessionStorage.setItem("name", name);
    }

    return (
        <AuthContext.Provider
            value={{
                user,
                signOut,
                signUp,
                login,
                loading: isLoading
            }}
        >
            {props.children}
        </AuthContext.Provider>
    )
}